var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcareIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Healthcare_Icons",
    clipPath: "url(#clip0_11406_3389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.98 24.5681C16.98 24.5681 11.1129 24.1137 9.80318 18.1331C8.6605 17.7923 5.51313 12.2058 8.31302 12.0388C7.91876 8.73771 7.41091 1.48071 16.98 1.48071H22.2189",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0205 24.5681C17.0205 24.5681 22.8876 24.1137 24.1973 18.1331C25.34 17.7923 28.4874 12.2058 25.6875 12.0388C25.9614 9.72002 26.603 5.53689 22.6537 3.91977",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.239 8.9315C17.8353 8.9315 13.7792 6.03137 13.7792 6.03137C13.7792 6.03137 13.2112 8.42364 11.8413 8.9315",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.982687 37.1442C0.982687 37.1442 0.541654 32.4933 3.92959 30.482C6.8364 28.945 12.5297 26.1518 12.5297 26.1518L17.0203 37.1442",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.0175 37.1041C33.0175 37.1041 33.4719 32.5 30.0907 30.4887C27.1839 28.9517 21.4905 26.1585 21.4905 26.1585L17 37.1509",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.4907 26.1585L24.1637 32.4265",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.4825 37.1041H27.1507V35.4202C27.1507 33.7697 25.8143 32.4265 24.1638 32.4265C22.5132 32.4265 21.1768 33.763 21.1768 35.4202V37.1041H21.845",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.5098 26.1585L9.83691 34.1105",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.83671 37.1442C10.6745 37.1442 11.3536 36.4651 11.3536 35.6274C11.3536 34.7896 10.6745 34.1105 9.83671 34.1105C8.99896 34.1105 8.31982 34.7896 8.31982 35.6274C8.31982 36.4651 8.99896 37.1442 9.83671 37.1442Z",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.8086 31.0567H19.0519",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 14.3476,
    cy: 14.1303,
    r: 1.00235,
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 19.4594,
    cy: 14.1303,
    r: 1.00235,
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.3872 18.1397C16.1246 19.4829 17.715 19.4829 19.1383 18.1397",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11406_3389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4116,
    height: 37,
    fill: "white",
    transform: "translate(0.294434 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareIcons);
export default __webpack_public_path__ + "static/media/Healthcare_Icons.a13c3988f6960068eb1301915096bb95.svg";
export { ForwardRef as ReactComponent };